import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseConfig, FuseConfigService, Scheme } from '@fuse/services/config';
import { Subject, takeUntil } from 'rxjs';

const SCHEME_STORAGE_KEY = 'smart-scheme';

@Component({
    selector: 'scheme-toggle',
    templateUrl: './scheme-toggle.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatTooltipModule],
})
export class SchemeToggleComponent implements OnInit, OnDestroy {
    scheme: 'dark' | 'light' = 'light';
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(private _fuseConfigService: FuseConfigService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes to keep the icon in sync with the active scheme
        this._fuseConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config: FuseConfig) => {
                this.scheme = config.scheme === 'dark' ? 'dark' : 'light';
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle between the dark and light schemes and persist the choice
     */
    toggleScheme(): void {
        const next: Scheme = this.scheme === 'dark' ? 'light' : 'dark';

        // Reuse Fuse's config flow; this applies the `.dark`/`.light` class to the body
        this._fuseConfigService.config = { scheme: next };

        // Persist so the preference survives reloads and new sessions
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(SCHEME_STORAGE_KEY, next);
        }
    }
}
